import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=733a9ffa"
import script from "./minimal.vue?vue&type=script&lang=js"
export * from "./minimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheHeader: require('/vercel/path0/components/TheHeader.vue').default,TheFooter: require('/vercel/path0/components/TheFooter.vue').default,BeAgentPopup: require('/vercel/path0/components/partials/BeAgentPopup.vue').default,Network: require('/vercel/path0/components/common/Network.vue').default})
